module.exports = __webpack_public_path__ + "static/media/Partner-LogosDomicile.c34f3ef2.png";